import React, { FunctionComponent } from 'react';

import styles from './DateLocation.module.scss';
import { Grid } from '@material-ui/core';
import { newFormater } from 'app/utils/dateTimeFormatter';
import { _t } from 'app/utils/i18n';
import { getFromLocalStorage } from 'app/utils/localStorage';
import { nFormatter } from 'app/utils/numbersFormater';

interface Props {
  is_caption_edited?: boolean;
  created_at: string;
  location?: string;
  time?: string;
  views?: number;
}

const DateLocation: FunctionComponent<Props> = ({
  created_at,
  is_caption_edited,
  location,
  time,
  views,
}) => {
  const isEn = !!(getFromLocalStorage('LNG') == 'en');
  return (
    <div style={{display:'flex', gap:'0.5rem',marginBottom:'0.5rem'}} className={styles.DateLocation}>
      <span>
        {is_caption_edited ? `${_t('posts:edited')} . ` : ''}
        {created_at
          ? newFormater(
              created_at,
              `hh:mm a . ${!isEn ? 'dd LLLL yyyy' : 'LLL dd,yyyy'}`,
            )
          : ''}
        {time ? time : ''}
      </span>
      {location && <span>{` ${_t('from')} ${location}`}</span>}
      {views !== undefined && (
        <span className={styles.views_counter}>
          <span>{nFormatter(views)}</span> {_t('trends:views')}
        </span>
      )}
    </div>
  );
};

export default DateLocation;
